export { default as Img200 } from './processed/200/Reign-Of-Fire.jpg';
export { default as Img400 } from './processed/400/Reign-Of-Fire.jpg';
export { default as Imgthumb } from './processed/thumb/Reign-Of-Fire.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Reign-Of-Fire.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Reign-Of-Fire.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      242,
      171,
      44
    ],
    "_population": 1417,
    "_hsl": [
      0.1069023569023569,
      0.8839285714285713,
      0.5607843137254902
    ]
  },
  "LightVibrant": {
    "_rgb": [
      247,
      213,
      85
    ],
    "_population": 2114,
    "_hsl": [
      0.13168724279835392,
      0.9101123595505618,
      0.6509803921568628
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      112,
      41,
      13
    ],
    "_population": 2749,
    "_hsl": [
      0.047138047138047146,
      0.792,
      0.24509803921568626
    ]
  },
  "Muted": {
    "_rgb": [
      152,
      92,
      90
    ],
    "_population": 45,
    "_hsl": [
      0.005376344086021487,
      0.256198347107438,
      0.4745098039215686
    ]
  },
  "LightMuted": {
    "_rgb": [
      172,
      153,
      118
    ],
    "_population": 27,
    "_hsl": [
      0.10802469135802466,
      0.2454545454545455,
      0.5686274509803921
    ]
  },
  "DarkMuted": {
    "_rgb": [
      83,
      47,
      48
    ],
    "_population": 730,
    "_hsl": [
      0.9953703703703703,
      0.27692307692307694,
      0.2549019607843137
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Reign-Of-Fire.js